import { render } from "./Gallery.vue?vue&type=template&id=2a944df3&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=2a944df3&lang=scss&scoped=true"

import exportComponent from "D:\\nawarat-libya\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a944df3"]])

export default __exports__